import { Source } from "cms/shared/enums";
import { getCurrentLanguage } from "cms/shared/language-helper";

class HouseWidget {
  private lang;
  private coverageOptions = document.querySelectorAll('.selection-box');
  private redirectButton = document.getElementById('redirect-button');

  constructor() {
    this.lang = getCurrentLanguage();
    this.coverageOptions.forEach((option) => {
      option.addEventListener('click', () => {
        this.redirectToFlow();
      });
    });
    this.redirectButton.addEventListener('click', () => {
      this.redirectToFlow();
    });
  }

  redirectToFlow() {
    const targetPath = this.lang === 'nl' ? 'verzekeringen/vergelijk/brandverzekering/waarborg' : 'assurances/comparer/assurance-habitation/selection-garantie';
    const params = new URLSearchParams(window.location.search);
    params.set('origin', Source.Widget);
    const queryString = params.toString();
    window.open(`${window.location.origin}/${targetPath}?${queryString}`);
  }
}

new HouseWidget();
